import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultiSelectModule } from 'primeng/multiselect';
import { TreeModule } from 'primeng/tree';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import {TooltipModule} from 'primeng/tooltip';
import {EditorModule} from 'primeng/editor';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    InputTextModule,
    MultiSelectModule,
    AutoCompleteModule,
    CalendarModule,
    DropdownModule,
    TableModule,
    TreeModule,
    EditorModule,
    TooltipModule
  ],
  exports :[
    InputTextModule,
    MultiSelectModule,
    AutoCompleteModule,
    CalendarModule,
    DropdownModule,
    TableModule,
    TreeModule,
    EditorModule,
    TooltipModule
  ]
})
export class UiFeaturedModule { }
